import * as React from 'react';
import { set } from 'lodash-es';
import { StateJson, Component, EditorActionsManager, UpdateStateAction } from '@easytwin/runtime';
import { observer } from 'mobx-react-lite';
import { deepClone } from '@/utils';
import { UISchema } from '@/type';
import { Primitive } from '../UIGenerator/uicomponents/Primitive';

interface StateTabsPanelProps {
  value: StateJson[];
  comp: Component;
  formSchema: UISchema;
}

export const FunctionalCompPlane: React.FC<React.PropsWithChildren<StateTabsPanelProps>> = observer(
  (props) => {
    const { value, comp, formSchema } = props;
    const selectedStateId = comp.selectedStateId;
    const curStateConfig = value.find((a) => a.id === selectedStateId)?.config;
    console.log('cur selected id', comp.name, comp.selectedStateId, value);
    const editorActionMgr = comp.engine.getManager(EditorActionsManager);
    const oldStateConfigRef = React.useRef<any>();
    const isEditing = React.useRef<boolean>(false);

    React.useEffect(() => {
      if (selectedStateId === undefined && value && value.length > 0) {
        comp.selectState(value[0].id);
        console.log('默认选中', comp.name, value[0].id);
      }
    }, [comp, selectedStateId, value]);

    const onStateUpdate = (name: string, value: unknown) => {
      if (!selectedStateId) return;
      const newState = deepClone(curStateConfig);
      set(newState, name, value);
      comp.updateState(selectedStateId, newState, false);

      if (isEditing.current === false) {
        isEditing.current = true;
        // 由于onStateUpdate会修改组件的states数据，所以无法在editorAction中拿到旧数据，只能提前储存
        oldStateConfigRef.current = deepClone(curStateConfig);
      }
    };

    const onStateConfirm = (name: string, value: unknown) => {
      if (!selectedStateId || !editorActionMgr) return;
      isEditing.current = false;
      const newState = deepClone(curStateConfig);
      set(newState, name, value);
      // 如果是输入框输入的撤回就读取oldStateConfigRef.current，如果是没有update直接confirm的组件（如select、checkbox）则直接获取curStateConfig
      const oldStateConfig = oldStateConfigRef.current || curStateConfig;

      editorActionMgr.execute(
        new UpdateStateAction(comp, selectedStateId, newState, oldStateConfig),
      );
    };

    const children = formSchema.map((a, index) => (
      <Primitive
        key={index}
        target={curStateConfig}
        schema={a}
        comp={comp}
        onChange={onStateUpdate}
        onConfirm={onStateConfirm}
      />
    ));

    return value && <div>{children}</div>;
  },
);
